import { useTranslation } from 'react-i18next'

const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur', 'prs', 'sd', 'ku', 'ug', 'ky', 'zh-Hant']

export const useRTL = () => {
  const { i18n } = useTranslation()
  const currentLanguage = i18n.language

  // Check if the current language is RTL
  const isRTL = RTL_LANGUAGES.includes(currentLanguage) || 
                i18n.dir && i18n.dir() === 'rtl'

  return { isRTL, currentLanguage }
}